import { render } from "./PdfEntirePageExtraction.vue?vue&type=template&id=3c9356d7&scoped=true"
import script from "./PdfEntirePageExtraction.vue?vue&type=script&lang=js"
export * from "./PdfEntirePageExtraction.vue?vue&type=script&lang=js"

import "./PdfEntirePageExtraction.vue?vue&type=style&index=0&id=3c9356d7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9356d7"]])

export default __exports__